import i18next from 'i18next';
import { toast } from 'sonner';
import { fetchDropdownOptionsFromReference } from '@/lib/reference-dropdown.helper.js';

export class RecipientGroupIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        try {
            const response = await this.service.getAll(params);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async getById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(
                response.message ||
                    i18next.t('integrationToasts:createdSuccessfully', {
                        defaultValue: 'Created successfully',
                    }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(
                response.message ||
                    i18next.t('integrationToasts:updatedSuccessfully', {
                        defaultValue: 'Updated successfully',
                    }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async delete(id) {
        try {
            await this.service.delete(id);
            toast.success(
                i18next.t('integrationToasts:deletedSuccessfully', {
                    defaultValue: 'Deleted successfully',
                }),
            );
            return { success: true };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    /**
     * PD inventory / transfer forms — prefer reference cache, then dropdown API / list.
     */
    async fetchDropdownData() {
        try {
            return await fetchDropdownOptionsFromReference('recipientGroup', async () => {
                if (typeof this.service.getDropdownParams === 'function') {
                    const response = await this.service.getDropdownParams();
                    return { success: true, data: response.data || [] };
                }
                const response = await this.service.getAll({ page: 1, pageSize: 1000, status: 'active' });
                return { success: true, data: response.data || [] };
            });
        } catch (error) {
            return { success: false, error: error.message, data: [] };
        }
    }
}
